import { Component, OnInit } from '@angular/core';
import { UserService } from '../user/user.service';
import { interval } from "rxjs/observable/interval";
import { startWith } from "rxjs/operators";
import { Subscription } from 'rxjs/Rx';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../shared/shared.service';
import { Logger } from 'angular2-logger/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-users-pending',
  templateUrl: './users-pending.component.html',
  styleUrls: ['./users-pending.component.scss'],
  providers: [UserService]
})
export class UsersPending implements OnInit {

  public listUsers: any;
  public roomsMsg : any;
  public dataHistorialRooms : any;
  public states: any;
  public title_toModal: string;
  public body_toModal: string;
  public arrayCheck = [];
  public arrayCheckSel = [];
  public template_id : any;

  public info_templates: any;
  public detalle_plantilla : any;
  public variables : any;
  public userId : any;

  public dataExcel: any = [];

  public countEspera : any;

  public list_var_users: any;

  public valorHtml : any;

  // Observadores.
  private intervalSub: Subscription;
  private intervalSubByStatus: Subscription;
  constructor(
    private spinner: NgxSpinnerService, 
    private _sharedService: SharedService,
    private userService: UserService,
    private logger: Logger, 
    public toastr: ToastsManager) { }

  ngOnInit() {
    this.valorHtml = '{{}}';
    this.getData(true);
    // Nuevos desarrollos.
    this.intervalSub = interval(40000).pipe(
      startWith(20000)).subscribe(i => {
        this.getData(false);
    });
  }

  private getData(mostrarSpinner: boolean) {
    //this.load = true;
    if (mostrarSpinner) { 
      this.spinner.show();
    }
    let data = {
      auth_token: this._sharedService.getCookie("auth_token"),
    };

    this.userService.getUsersPending(data).subscribe(  
      data => {
        this.listUsers = data.data.data;

        this.countEspera = this.listUsers.length;

        for (let i in data.data.data) {
            let tempExcel = [];
                tempExcel['Canal']          = data.data.data[i].channel;
                tempExcel['Id de sesión']   = data.data.data[i].session_id;
                tempExcel['Id del usuario'] = data.data.data[i].sender_id_bot;
                tempExcel['Fecha']          = data.data.data[i].created_at;

            this.dataExcel.push(tempExcel);
        }

        console.log(this.listUsers);

        if (mostrarSpinner) { 
          this.spinner.hide();
        }
      },
      error => { //server error
        this.logger.log("Ocurrió un error al consultar los agentes", error);
        //this.load = false;
        this.spinner.hide();
      }

    );
  }

  enviarPush(id, session_id) {
    this.userId = id;
    this.spinner.show();

    let data = {
        auth_token: this._sharedService.getCookie("auth_token"),
        session_id : session_id
    }

    this.userService.getTemplatesRooms(data).subscribe(
        data => {
            if (data.message == 'errorAgent') {
                this.spinner.hide();
                this.toastr.error("El usuario se encuentra con un agente, intentalo más tarde", 'Error');
                return;
            }

            if (data.message == 'errorBot') {
                this.spinner.hide();
                this.toastr.error("El usuario se encuentra interactuando con el bot, intentalo más tarde", 'Error');
                return;
            }

            if (data.data.length > 0) {
                //this.active_agents = data.data;
                this.info_templates = data.data;
                this.title_toModal = "Plantillas disponibles";
                this.body_toModal = "";
                $('#verPlantillas').modal('toggle',{backdrop: false});
                $('#verPlantillas').appendTo("body");
                this.spinner.hide();
            } else {
                this.title_toModal = "Advertencia";
                this.body_toModal = "No hay plantillas disponible";
                $('#verPlantillas').modal('toggle',{backdrop: "false"});
                $('#verPlantillas').appendTo("body");
                this.spinner.hide();
            }
        }, () => {
            this.title_toModal = "Advertencia";
            this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
            $('#verPlantillas').modal('toggle', {backdrop: "false"});
            $('#verPlantillas').appendTo("body");
            this.spinner.hide();
        });
    }

    verPlantilla(id) {
        this.template_id = id;

        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            template_id: id
        };
        this.spinner.show();

        this.userService.getTemplateId(data).subscribe(
            data => {
                if (data.status) {
                    this.detalle_plantilla = data.data.detalle; 
                    $('#detailTemplate').modal('toggle');
                } else {
                    this.toastr.error(data.message, 'Error');
                }
                //this.load = false;
                this.spinner.hide();
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }

    selectTemplates(id) {
        this.template_id = id;

        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            template_id: id
        };

        this.spinner.show();

        this.userService.getTemplateId(data).subscribe(
            data => {
                if (data.status) {
                    this.detalle_plantilla = data.data.detalle;
                } else {
                    this.toastr.error(data.message, 'Error');
                }
                //this.load = false;
                this.spinner.hide();
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );

        this.spinner.show();

        this.userService.getTemplateVariables(data).subscribe(
            data => {
                console.log(data);
                if (data.status) {
                    this.variables = data.data;
                    $('#variablesTemplate').modal('toggle');
                } else {
                    this.toastr.error(data.message, 'Error');
                }
                //this.load = false;
                this.spinner.hide();
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }

    sendPush() {
        let valorVariables = [];
        for (let i = 0; i < this.variables.length; i++) {
            valorVariables.push((<HTMLInputElement>document.getElementById(this.variables[i].valor)).value);
        }

        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            variables: valorVariables,
            userId: this.userId,
            template_id : this.template_id
        };
        
        this.spinner.show();

        this.userService.sendPushUserPending(data).subscribe(
            data => {
                console.log(data);
                if (data.status) {
                    this.toastr.success('Mensaje enviado con éxito', 'Éxito!');
                    this.getData(false);
                    this.spinner.hide();
                } else {
                    this.spinner.hide();
                    this.toastr.error(data.message, 'Error');
                }
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );


        console.log(valorVariables);
    }

    exportAsXLSX(): void {
        this.userService.exportAsExcelFile(this.dataExcel, 'reporte');
    }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/users-pending/users-pending.component.ts